import React, { useState, useEffect } from 'react'
import axios from 'axios';
import CardGripMapSemanal from './CardGripMapSemanal';
import CardGripMapMensual from './CardGripMapMensual';
import RankingSedes from './RankingSedes';
import { Metric } from '@tremor/react';
import BotonAcceso from '../elementos/BotonAcceso.jsx';
import {
  RefreshCw,
  BarChart3,
  Calendar,
  Filter,
  LayoutDashboard,
  TrendingUp,
  LineChart,
  Trophy
} from 'lucide-react';
import { useTheme } from "../guardarToken/themeContext";

const apiUrlSedes = process.env.REACT_APP_API_SEDES || '/api/sedes/';

const Dashpage = () => {
  const { isDarkMode } = useTheme();
  const [tab, setTab] = useState(1);
  const [key, setKey] = useState(0);
  const [desde, setDesde] = useState("");
  const [hasta, setHasta] = useState("");
  const [mes, setMes] = useState("");
  const [sedes, setSedes] = useState([]);
  const [sedeFilter, setSedeFilter] = useState('todas');

  useEffect(() => {
    const getSedes = async () => {
      try {
        const res = await axios.get(apiUrlSedes);
        setSedes(Array.isArray(res.data) ? res.data : []);
      } catch (error) {
        console.error('Error al obtener sedes:', error);
        setSedes([]);
      }
    };
    getSedes();
  }, []);

  const handleRefresh = () => {
    setKey(prev => prev + 1);
  };

  return (
    <div className={`min-h-screen p-3 lg:p-4 font-sans transition-colors duration-300 ${isDarkMode ? "bg-slate-950 text-white" : "bg-slate-50 text-slate-800"}`}>

      {/* HEADER PREMIUM */}
      <div className={`${isDarkMode ? "bg-slate-900 border-slate-800" : "bg-white border-slate-200"} rounded-2xl shadow-sm p-5 mb-6 flex flex-col md:flex-row items-center justify-between border ring-1 ring-black/5 animate-in slide-in-from-top duration-700`}>
        <div className="flex items-center gap-4">
          <div className="bg-gradient-to-br from-blue-500 to-blue-700 p-3 rounded-xl shadow-lg shadow-blue-900/20">
            <LayoutDashboard className="text-white w-6 h-6" />
          </div>
          <div>
            <h1 className="text-xl font-black tracking-tight leading-none mb-1">Panel de Control</h1>
            <p className={`text-[11px] ${isDarkMode ? "text-slate-400" : "text-slate-500"} font-black uppercase tracking-wider`}>Analítica y estadísticas de pedidos</p>
          </div>
        </div>

        <div className="flex items-center gap-3 mt-4 md:mt-0">
          <BotonAcceso
            variant="accent"
            onClick={handleRefresh}
            className="bg-blue-600 hover:bg-blue-700 text-white font-black text-[11px] uppercase tracking-widest px-5 py-2.5 rounded-xl shadow-lg shadow-blue-950/20 flex items-center gap-2 transform hover:scale-[1.02] transition-all"
          >
            <RefreshCw className="w-4 h-4" /> Recargar Datos
          </BotonAcceso>
        </div>
      </div>

      {/* FILTER BAR */}
      <div className={`${isDarkMode ? "bg-slate-900 border-slate-800 shadow-xl" : "bg-white border-slate-200 shadow-sm"} rounded-2xl p-6 mb-8 border animate-in slide-in-from-left duration-700`}>
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8">

          <div className="space-y-4 flex-1">
            <div className="flex items-center gap-2 mb-2">
              <Filter className="text-blue-500 w-5 h-5" />
              <h2 className="text-sm font-black uppercase tracking-widest">Filtros de Análisis</h2>
            </div>

            <div className="flex flex-wrap items-center gap-4">
              {/* TABS SELECTOR */}
              <div className={`flex p-1 rounded-xl ${isDarkMode ? "bg-slate-950" : "bg-slate-100"}`}>
                <button
                  onClick={() => setTab(1)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-[11px] font-black uppercase tracking-wider transition-all ${tab === 1 ? (isDarkMode ? "bg-slate-800 text-blue-400 shadow-lg" : "bg-white text-blue-600 shadow-md") : "text-slate-500 hover:text-slate-400"}`}
                >
                  <TrendingUp className="w-3.5 h-3.5" /> Diario
                </button>
                <button
                  onClick={() => setTab(2)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-[11px] font-black uppercase tracking-wider transition-all ${tab === 2 ? (isDarkMode ? "bg-slate-800 text-blue-400 shadow-lg" : "bg-white text-blue-600 shadow-md") : "text-slate-500 hover:text-slate-400"}`}
                >
                  <LineChart className="w-3.5 h-3.5" /> Mensual
                </button>
                <button
                  onClick={() => setTab(3)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-[11px] font-black uppercase tracking-wider transition-all ${tab === 3 ? (isDarkMode ? "bg-slate-800 text-blue-400 shadow-lg" : "bg-white text-blue-600 shadow-md") : "text-slate-500 hover:text-slate-400"}`}
                >
                  <Trophy className="w-3.5 h-3.5" /> Ranking
                </button>
              </div>

              <div className="h-8 w-px bg-slate-800 mx-2 hidden sm:block" />

              {/* Filtro por Sede */}
              <div className="space-y-1">
                <span className="text-[9px] font-black uppercase tracking-widest text-slate-500 ml-1">Sede</span>
                <select
                  value={sedeFilter}
                  onChange={(e) => setSedeFilter(e.target.value)}
                  className={`px-4 py-2 rounded-xl text-xs font-bold focus:outline-none transition-all ${isDarkMode ? "bg-slate-950 border-slate-800 text-white" : "bg-slate-50 border-slate-200 text-slate-800"} border`}
                >
                  <option value="todas">Todas las Sedes</option>
                  {(sedes || []).map(sede => (
                    <option key={sede.id} value={sede.id}>{sede.nombre}</option>
                  ))}
                </select>
              </div>

              <div className="h-8 w-px bg-slate-800 mx-2 hidden sm:block" />

              {/* INPUTS DINÁMICOS */}
              {tab === 1 ? (
                <div className="flex flex-wrap items-center gap-4 animate-in fade-in duration-500">
                  <div className="space-y-1">
                    <span className="text-[9px] font-black uppercase tracking-widest text-slate-500 ml-1">Desde</span>
                    <div className="relative">
                      <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500 pointer-events-none" />
                      <input
                        type="date"
                        value={desde}
                        onChange={e => setDesde(e.target.value)}
                        className={`pl-10 pr-4 py-2 rounded-xl text-xs font-bold focus:outline-none transition-all ${isDarkMode ? "bg-slate-950 border-slate-800 text-white" : "bg-slate-50 border-slate-200 text-slate-800"} border`}
                      />
                    </div>
                  </div>
                  <div className="space-y-1">
                    <span className="text-[9px] font-black uppercase tracking-widest text-slate-500 ml-1">Hasta</span>
                    <div className="relative">
                      <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500 pointer-events-none" />
                      <input
                        type="date"
                        value={hasta}
                        onChange={e => setHasta(e.target.value)}
                        className={`pl-10 pr-4 py-2 rounded-xl text-xs font-bold focus:outline-none transition-all ${isDarkMode ? "bg-slate-950 border-slate-800 text-white" : "bg-slate-50 border-slate-200 text-slate-800"} border`}
                      />
                    </div>
                  </div>
                </div>
              ) : tab === 2 ? (
                <div className="flex flex-wrap items-center gap-4 animate-in fade-in duration-500">
                  <div className="space-y-1">
                    <span className="text-[9px] font-black uppercase tracking-widest text-slate-500 ml-1">Seleccionar Mes</span>
                    <div className="relative">
                      <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500 pointer-events-none" />
                      <input
                        type="month"
                        value={mes}
                        onChange={e => setMes(e.target.value)}
                        className={`pl-10 pr-4 py-2 rounded-xl text-xs font-bold focus:outline-none transition-all ${isDarkMode ? "bg-slate-950 border-slate-800 text-white" : "bg-slate-50 border-slate-200 text-slate-800"} border`}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="flex flex-wrap items-center gap-4 animate-in fade-in duration-500">
                  <div className="space-y-1">
                    <span className="text-[9px] font-black uppercase tracking-widest text-slate-500 ml-1">Seleccionar Mes</span>
                    <div className="relative">
                      <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500 pointer-events-none" />
                      <input
                        type="month"
                        value={mes}
                        onChange={e => setMes(e.target.value)}
                        className={`pl-10 pr-4 py-2 rounded-xl text-xs font-bold focus:outline-none transition-all ${isDarkMode ? "bg-slate-950 border-slate-800 text-white" : "bg-slate-50 border-slate-200 text-slate-800"} border`}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="hidden xl:flex flex-col items-end gap-1">
            <div className="flex items-center gap-2 text-emerald-500 font-black text-xs uppercase tracking-widest">
              <BarChart3 className="w-4 h-4" /> Datos en tiempo real
            </div>
            <p className="text-[10px] text-slate-500 font-medium">Sincronizado con base de datos Def-Software</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-8 animate-in slide-in-from-bottom duration-1000" key={key}>
        {tab === 1 ? (
          <div className={`${isDarkMode ? "bg-slate-900/50 border-slate-800" : "bg-white border-slate-200"} rounded-3xl p-6 border shadow-sm`}>
            <div className="flex items-center gap-3 mb-6 border-b border-slate-800/50 pb-4">
              <div className="w-8 h-8 rounded-lg bg-indigo-500/10 flex items-center justify-center">
                <TrendingUp className="w-4 h-4 text-indigo-500" />
              </div>
              <h3 className="text-sm font-black uppercase tracking-widest">Cantidades por Día</h3>
            </div>
            <CardGripMapSemanal desde={desde} hasta={hasta} sedeId={sedeFilter} />
          </div>
        ) : tab === 2 ? (
          <div className={`${isDarkMode ? "bg-slate-900/50 border-slate-800" : "bg-white border-slate-200"} rounded-3xl p-6 border shadow-sm`}>
            <div className="flex items-center gap-3 mb-6 border-b border-slate-800/50 pb-4">
              <div className="w-8 h-8 rounded-lg bg-blue-500/10 flex items-center justify-center">
                <LineChart className="w-4 h-4 text-blue-500" />
              </div>
              <h3 className="text-sm font-black uppercase tracking-widest">Seguimiento Mensual</h3>
            </div>
            <CardGripMapMensual mes={mes} sedeId={sedeFilter} />
          </div>
        ) : (
          <div className={`${isDarkMode ? "bg-slate-900/50 border-slate-800" : "bg-white border-slate-200"} rounded-3xl p-6 border shadow-sm`}>
            <div className="flex items-center gap-3 mb-6 border-b border-slate-800/50 pb-4">
              <div className="w-8 h-8 rounded-lg bg-yellow-500/10 flex items-center justify-center">
                <Trophy className="w-4 h-4 text-yellow-500" />
              </div>
              <h3 className="text-sm font-black uppercase tracking-widest">Ranking de Sedes</h3>
            </div>
            <RankingSedes mes={mes} />
          </div>
        )}
      </div>

      {/* FOOTER METRICS INFO (Optional decorative) */}
      <div className="mt-12 flex flex-wrap justify-center gap-12 opacity-40 grayscale group-hover:grayscale-0 transition-all duration-700">
        <div className="flex flex-col items-center">
          <Metric className="!text-sm mb-1" color={isDarkMode ? "white" : "dark"}>REPORTES</Metric>
          <p className="text-[8px] font-black uppercase tracking-[0.3em]">Automatizados</p>
        </div>
        <div className="flex flex-col items-center">
          <Metric className="!text-sm mb-1" color={isDarkMode ? "white" : "dark"}>FILTROS</Metric>
          <p className="text-[8px] font-black uppercase tracking-[0.3em]">Dinámicos</p>
        </div>
        <div className="flex flex-col items-center">
          <Metric className="!text-sm mb-1" color={isDarkMode ? "white" : "dark"}>EXPORTAR</Metric>
          <p className="text-[8px] font-black uppercase tracking-[0.3em]">Formatos PDF/XLS</p>
        </div>
      </div>
    </div>
  )
}

export default Dashpage
